<template>
  <div>
    <p class="gp-content-title">
      {{ title }}
    </p>
    <p class="gp-content-body">
      {{ body }}
    </p>

    <p class="g-mt-6 g-mb-12" v-if="link">
      <a target="_blank" class="g-font-bold g-px-4 g-py-2 g-rounded g-bg-grey-300 hover:g-text-white hover:g-bg-green-500" :href="link">Mehr Informationen</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "SectionContent",

  props: ["title", "body", "link"],
};
</script>

<style></style>
